import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
    return (
        <Typewriter
            options={{
                strings: [
                    "Mechanical Engineer",
                    "Propulsion Engineer",
                    "Thermo-Fluid Engineer",
                    "Engineering Consultant",
                    "Design Engineer",
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
            }}
        />
    );
}

export default Type;
